import { builtIn, override } from "./rules.js";
import { baseRules } from "./base.js";

export const bulma = builtIn({
  id: "bulma",
  name: "Bulma",
  basedOn: "bulma",
  description: "Bulma markup inside a .content wrapper: title and subtitle, notifications, messages, tags and styled tables.",
  css: ["vendor/bulma.min.css"],
  exportCss: ["https://cdn.jsdelivr.net/npm/bulma@1.0.4/css/bulma.min.css"],
  wrapper: "div.content",
  exportWrapper: "section.section > div.container > div.content",
  rules: override(baseRules, {
    "p|Title": { html: "h1.title:fresh" },
    "p|Subtitle": { html: "p.subtitle:fresh" },
    "p|Lead": { html: "p.is-size-5:fresh" },
    "p|Intense Quote": { html: "blockquote.has-text-weight-semibold > p:fresh" },
    "p|Caption": { html: "p.is-size-7:fresh" },
    "p|Note": { html: "div.notification.is-info > p:fresh" },
    "p|Tip": { html: "div.notification.is-success > p:fresh" },
    "p|Important": { html: "article.message.is-primary > div.message-body > p:fresh" },
    "p|Warning": { html: "div.notification.is-warning > p:fresh" },
    "p|Caution": { html: "div.notification.is-danger > p:fresh" },
    "r|Badge": { html: "span.tag" },
    "table|Grid Table*": { html: "table.table.is-bordered" },
    "table|List Table*": { html: "table.table.is-striped" },
    "table|": { html: "table.table" },
  }),
});
